import LazyComponent from './LazyComponent';

export default LazyComponent;
